import type {
  SimpleValidationRuleFunction,
  ValidationRuleDictionary,
} from '../types';
import {
  arrayValuesMatchRegex,
  atLeastOneRequired,
  cityValidation,
  date,
  dateIsNotTooOld,
  dateIsNotTooYoung,
  dateMustBeAfterAnother,
  decimal,
  fieldIsRequiredIfAnother,
  fieldsMustBeTheSame,
  internationalPhoneNumber,
  italianZipCode,
  nameOrSurname,
  noBackslash,
  objectValueEmail,
  password,
  provinceCode,
  swanEmail,
  taxId,
  taxIdOrUndefined,
  time,
  url,
  vatNumber,
} from './custom-rules';

export const customRules: ValidationRuleDictionary = {
  arrayValuesMatchRegex: arrayValuesMatchRegex as SimpleValidationRuleFunction,
  italianPostalCode: italianZipCode as SimpleValidationRuleFunction,
  nameOrSurname: nameOrSurname as SimpleValidationRuleFunction,
  taxId: taxId as SimpleValidationRuleFunction,
  internationalPhoneNumber:
    internationalPhoneNumber as SimpleValidationRuleFunction,
  taxIdOrUndefined: taxIdOrUndefined as SimpleValidationRuleFunction,
  atLeastOneRequired: atLeastOneRequired as SimpleValidationRuleFunction,
  fieldsMustBeTheSame: fieldsMustBeTheSame as SimpleValidationRuleFunction,
  fieldIsRequiredIfAnother:
    fieldIsRequiredIfAnother as SimpleValidationRuleFunction,
  password: password as SimpleValidationRuleFunction,
  provinceCode: provinceCode as SimpleValidationRuleFunction,
  date: date as SimpleValidationRuleFunction,
  time: time as SimpleValidationRuleFunction,
  decimal: decimal as SimpleValidationRuleFunction,
  dateIsNotTooOld: dateIsNotTooOld as SimpleValidationRuleFunction,
  dateIsNotTooYoung: dateIsNotTooYoung as SimpleValidationRuleFunction,
  swanEmail: swanEmail as SimpleValidationRuleFunction,
  dateMustBeAfterAnother:
    dateMustBeAfterAnother as SimpleValidationRuleFunction,
  cityValidation: cityValidation as SimpleValidationRuleFunction,
  noBackslash: noBackslash as SimpleValidationRuleFunction,
  objectValueEmail: objectValueEmail as SimpleValidationRuleFunction,
  url: url as SimpleValidationRuleFunction,
  vatNumber: vatNumber as SimpleValidationRuleFunction,
};
